import { customizedFetch } from "./_customizedFetch";
import { appConstants } from "../utils";

export const Login = async (body) => {
  return await customizedFetch(`${appConstants.IQ_HUB_API_URL}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  });
};

export const IQGoogleLogin = async (body) => {
  return await customizedFetch(`${appConstants.IQ_HUB_API_URL}/auth/google`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  });
};

export const SignUp = async (body) => {
  return await customizedFetch(`${appConstants.IQ_HUB_API_URL}/signUp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
    credentials: "include",
  });
};

export const SignUpVerifyOtp = async (body) => {
  return await customizedFetch(
    `${appConstants.IQ_HUB_API_URL}/signUp/verifyOtp`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      credentials: "include",
    }
  );
};

export const SignUpResendOtp = async () => {
  return await customizedFetch(
    `${appConstants.IQ_HUB_API_URL}/signUp/resendOtp`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    }
  );
};

export const ForgotPassword = async (body) => {
  return await customizedFetch(
    `${appConstants.IQ_HUB_API_URL}/forgotPassword`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      credentials: "include",
    }
  );
};

export const ForgotPasswordVerifyOtp = async (body) => {
  return await customizedFetch(
    `${appConstants.IQ_HUB_API_URL}/forgotPassword/verifyOtp`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      credentials: "include",
    }
  );
};

export const ForgotPasswordResendOtp = async () => {
  return await customizedFetch(
    `${appConstants.IQ_HUB_API_URL}/forgotPassword/resendOtp`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    }
  );
};

export const ForgotPasswordResetConfirmation = async (body) => {
  return await customizedFetch(
    `${appConstants.IQ_HUB_API_URL}/forgotPassword/resetPassword`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      credentials: "include",
    }
  );
};

export const Logout = async () => {
  localStorage.removeItem(appConstants.IQ_HUB_TOKEN_NAME);
  return await customizedFetch(`${appConstants.IQ_HUB_API_URL}/logout`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};
